import type { TSharesCount } from '../models/share.types'

export const getTotalSharesCount = (sharesCount?: TSharesCount) =>
  sharesCount && Object.values(sharesCount).reduce((a, b) => a + b, 0)
